
const typeMap = {
    '编':1,
    '章':2,
    '节':3,
    '条':4,
}
// 解析法律文本 通过输入格式转换成JSON
export function extractStructure(text) {
    let strText = text + '【end】'
    const structure = [];
    let bian_parent = null
    let zhang_parent = null
    let jie_parent = null

    const regex = /【(编|章|节|条)：(.*?)】(.*?)(?=【(编|章|节|条|end)(.*?)】|Z)/gs;
    let match;
    while ((match = regex.exec(strText))) {
        const type = match[1];
        const title = match[2];
        const content = match[3];
        
        if (type === '编') {
            let index = title.slice(1, -1)
            const newObj = { titleNum:title, titleContent:content, children: [], type:typeMap[type],titleIndex:index};
            structure.push(newObj);
            bian_parent = newObj;
            bian_parent.children = []
            // 初始化
            zhang_parent = null
            jie_parent = null
        } else if ((type === '章')) {
            let index = title.slice(1, -1)
            const newObj = { titleNum:title, titleContent:content, children: [], type:typeMap[type],titleIndex:index};
            if(bian_parent){
                bian_parent.children.push(newObj);
            }else{
                structure.push(newObj);
            }
            zhang_parent = newObj;
            zhang_parent.children = []
            // 初始化
            jie_parent = null
        } else if (type === '节') {
            let index = title.slice(1, -1)
            const newObj = { titleNum:title, titleContent:content,children: [], type:typeMap[type],titleIndex:index};
            if(zhang_parent){
                zhang_parent.children.push(newObj);
            }else{
                if(bian_parent){
                    bian_parent.children.push(newObj);
                }else{
                    structure.push(newObj);
                }
            }
            jie_parent = newObj;
            jie_parent.children = []
        }else if (type === '条') {
            let index = title.slice(1, -1)
            const newObj = { titleNum:title, titleContent:content, type:typeMap[type],titleIndex:index };
            
            if(jie_parent){
                jie_parent.children.push(newObj);
            }else{
                if(zhang_parent){
                    zhang_parent.children.push(newObj);
                }else{
                    if(bian_parent){
                        bian_parent.children.push(newObj);
                    }else{
                        structure.push(newObj);
                    }
                }
            }
        }
    }
    return structure;
}

// 数组格式化目录
export function structureToTree(structure) {

    function parse(node) {
        node.title = `${node.titleNum} ${node.name}`
        node.title = node.title ? node.title.trim() : node.title
        // 递归处理子节点
        if (node.children && node.children.length > 0) {
            for (const child of node.children) {
                parse(child);
            }
        }
    }

    // 遍历解析结构数据
    for (const node of structure) {
        node.title = `${node.titleNum} ${node.name}`
        node.title = node.title ? node.title.trim() : node.title
        parse(node);
    }

    return structure;
}

// 反编译 通过JSON数据转换成输入格式
export function structureToText(structure) {
    let result = '';

    function parse(node) {
        // result += `【${node.type}：${node.title}】${node.content}`;

        if (node.type == 1) {
            result += `【编：${node.titleNum}】${node.titleContent}\n`;
        } else if (node.type == 2) {
            result += `【章：${node.titleNum}】${node.titleContent}\n`;
        } else if (node.type == 3) {
            result += `【节：${node.titleNum}】${node.titleContent}\n`;
        } else if (node.type == 4) {
            result += `【条：${node.titleNum}】${node.titleContent}\n`;
        }

        // 递归处理子节点
        if (node.children && node.children.length > 0) {
            for (const child of node.children) {
                parse(child);
            }
        }
    }

    // 遍历解析结构数据
    for (const node of structure) {
        parse(node);
    }

    return result;
}

// 预览 通过JSON转换成html格式
export function structureToView(structure) {
    let result = '';
    const classMap = {
        1:'bian',
        2:'zhang',
        3:'jie',
        4:'tiao'
    }
    function parse(node) {
        let content = node.titleContent.trim().replace(/\r|\n/g, '<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        
        result += `
            <div class=${classMap[node.type]} id=div${node.chapterCode || '-'}>
                <span class='title'>${node.titleNum}</span>
                <span>${content}</span>
            </div>
        `
        // 递归处理子节点
        if (node.children && node.children.length > 0) {
            for (const child of node.children) {
                parse(child);
            }
        }
    }

    // 遍历解析结构数据
    for (const node of structure) {
        parse(node);
    }

    return result;
}